import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel';
import { Password } from 'primereact/password';
import { useConsultantLogin } from '../hooks/useGetDataQuery';
import { useToastContext } from '../Lib/Contexts/toastContext';
import "./login.css";
import AboutUs from '../Support/aboutUs';

const Login = () => {
    const { showToast } = useToastContext();

    const { t }: any = useOutletContext();
    const [aboutUsdialogVisible, setAboutUsdialogVisible] = useState<any>(false);

    const {
        mutate: consultantLoginMutation,
        isError: isErrorConsultantLogin,
        isSuccess: isSuccessConsultantLogin,
        isPending: isPendingConsultantLogin,
    } = useConsultantLogin();

    const [formData, setFormData] = useState({
        username: '',
        password: ''
    })

    const [usernameError, setUsernameError] = useState("");
    const [passwordError, setPasswordError] = useState("");

    useEffect(() => {
        if (isSuccessConsultantLogin) {
            validateLogin();
        }
    }, [isSuccessConsultantLogin]);

    useEffect(() => {
        if (isErrorConsultantLogin) {
            showToast({ severity: 'error', summary: 'Error', detail: t("errorMessages.login.invalidCredentials") });
        }

    }, [isErrorConsultantLogin]);

    const navigate = useNavigate();

    const validateLogin = () => {
        navigate({ pathname: "/mobithera" });
    }

    const checkCredentials = () => {
        let valid = true;

        if (!formData.username) {
            setUsernameError('requiredField');
            valid = false;
        }

        if (!formData.password) {
            setPasswordError('requiredField');
            valid = false;
        }

        return valid;
    }

    const handleAPILogin = () => {
        if (!checkCredentials()) return;
        consultantLoginMutation(formData);
    }

    const handleEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;

        setFormData({
            ...formData,
            username: value
        })
    }

    const handlePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;

        setFormData({
            ...formData,
            password: value
        })
    }

    return (
        <>
            <p className='font-bold text-6xl m-0'><span style={{ color: "#2D3967" }}>{t("welcomeTo")}</span> <span style={{ color: "#E3506B" }}>Mobithera</span></p>
            <p className='text-4xl m-0' style={{ color: "#727A99" }}>{t('signInAccount')}</p>
            <div className='p-fluid w-full mt-6 mb-6'>
                <div className='flex flex-column gap-5 align-items-center mb-2'>
                    <div className='w-full'>
                        <FloatLabel>
                            <InputText style={{ border: "none", borderRadius: "10px" }} invalid={usernameError != "" && !formData.username} className='p-inputtext-lg w-full' variant="filled" id='email' value={formData.username} onChange={(e) => handleEmail(e)} onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleAPILogin();
                                }
                            }} />
                            <label htmlFor='email'>{t('email')}</label>
                        </FloatLabel>
                        {(usernameError != "" && !formData.username) && <small className='text-red-500 text-xs'>{t(usernameError)}</small>}
                    </div>
                    <div className='w-full'>
                        <FloatLabel>
                            <Password invalid={passwordError != "" && !formData.password} feedback={false} id="password" className='p-inputtext-lg w-full password' toggleMask variant='filled' value={formData.password} onChange={(e) => handlePassword(e)} onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleAPILogin();
                                }
                            }} />
                            <label htmlFor="password">{t('password')}</label>
                        </FloatLabel>
                        {(passwordError != "" && !formData.password) && <small className='text-red-500 text-xs'>{t(passwordError)}</small>}
                    </div>
                </div>
                {/* <div className='flex justify-content-between'>
                    <div className="flex align-items-center">
                        <Checkbox name="pizza" value="Cheese" onChange={e => setRemember(e.checked)} checked={remember} />
                        <label className="ml-2" style={{ color: "#2D3967" }}>{t('rememberMe')}</label>
                    </div>

                </div> */}
                <div className='flex flex-column align-items-end justify-content-center gap-4'>
                    <Button loading={isPendingConsultantLogin} onClick={handleAPILogin} style={{ backgroundColor: "#6383F4", borderRadius: "10px", border: "none" }} className='w-full mt-2' size="large" label={t('signIn')} severity='secondary' />


                    <div className='flex align-items-center justify-content-between gap-2 w-full'>
                        <span onClick={() => setAboutUsdialogVisible(true)} style={{ color: "#64ADF0", cursor: "pointer" }}>{t('aboutUs')}</span>
                        <span onClick={() => navigate('/sendEmail')} style={{ color: "#64ADF0", cursor: "pointer" }}>{t('forgotPass')} ?</span>
                        <AboutUs t={t} aboutUsdialogVisible={aboutUsdialogVisible} setAboutUsdialogVisible={setAboutUsdialogVisible} />
                    </div>
                </div>

            </div>
            {/* <div className='w-full flex justify-content-center'>
                <span className='font-medium' style={{color:"#2D3967"}}>{t('noAcc')}? <a href='/register' style={{color:"#2D3967"}} className='font-semibold'>{t('signUp')}</a></span>
            </div> */}

        </>
    );
}

export default Login